import { render } from "./PricingGroup.vue?vue&type=template&id=fc721e52&scoped=true"
import script from "./PricingGroup.vue?vue&type=script&lang=js"
export * from "./PricingGroup.vue?vue&type=script&lang=js"

import "./PricingGroup.vue?vue&type=style&index=0&id=fc721e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc721e52"]])

export default __exports__